import React, { useEffect } from 'react';

const Blog6: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <article className="max-w-6xl mx-auto p-6 mt-28 bg-white shadow-lg rounded-lg mb-8">
            <h1 className="text-3xl font-bold mb-2">Carpal Tunnel Unlocked – Simple Steps from Numb Hands to Full Grip Strength</h1>
            <div className="text-gray-600 mb-4">
                🗓️ <span>20th February, 2026</span>
            </div>

            <img src='/images/blog6.png' alt="Carpal Tunnel Unlocked" className="w-full h-80 object-contain rounded-lg mb-6" />

            <div className="prose max-w-none">
                <p>
                    Your hands fall asleep at night, fingers tingle during drives, and gripping a coffee mug weakens – classic carpal tunnel syndrome (CTS), where the median nerve in your wrist's tunnel gets crushed by swollen tendons. Affecting 3-6% of adults, especially women 45-60, it's fueled by repetitive motions like typing, vibrating tools, hypothyroidism, or rheumatoid arthritis fluid buildup. Unlike fingertip arthritis, CTS numbs thumb/index/middle fingers (pinky spared), drops small objects, or shocks with wrist taps (Tinel's sign). Advanced cases atrophy thumb muscles, making pinch impossible.
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">Home Fixes and Conservative Care</h2>
                <p>
                    Home fixes first: nighttime wrist splints keep the tunnel neutral, worn 6-8 weeks for 50% relief. Glide exercises – fist-to-star stretches 5x daily – prevent sticking tendons, and ergonomic tweaks like keyboard risers cut strain. Lose weight if overweight, as fat pads the tunnel. Dr. Gunjan also endorses ultrasound-guided cortisone shots for quick inflammation drop, lasting 3+ months in 60-80%.
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">Evaluation and Clinical Treatment</h2>
                <p>
                    Clinical evaluation includes provocative maneuvers such as Phalen's test and Tinel's sign, combined with nerve conduction studies (electromyography/NCS) to assess the degree of median nerve compression. When non-surgical interventions are ineffective, endoscopic or open carpal tunnel release may be considered to divide the transverse carpal ligament and relieve pressure within the canal.
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">Recovery and Ergonomic Prevention</h2>
                <p>
                    Postoperative care focuses on gentle finger mobilization, elevation, and appropriate wound care. Long-term management includes ergonomic workplace modifications, structured rest breaks during repetitive wrist motions, and hand therapy when needed to support grip strength and functional return.
                </p>
            </div>

            <button className="mt-6 bg-blue-800 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded">
                Schedule Appointment
            </button>
        </article>
    );
};

export default Blog6;
